import React from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import useRolesGql from './hooks/useRolesGql';

function ClientRolesSelect({ label, name, formInputChanged, value, valueName, ...remainingProps }) {
  const { makeStyles, SelectMui } = useUiContext();

  const useMenuStyles = makeStyles({
    menuPaper: {
      maxHeight: 175,
    },
  });
  const menuClasses = useMenuStyles();

  const { data, loading } = useRolesGql().useClientRolesQuery();

  if (loading) {
    return null;
  }

  const { clientRoles } = data;
  // Custom order, to add roles you must add in Constants.rb and then create in db with Role.find_or_create
  const roleListOrder = ['Bride', 'Bridesmaid', 'Mother Of Bride/Groom', 'Guest', 'Other'];
  const childrenOptions = clientRoles.map((role) => ({ id: role.id, value: role[valueName], label: role.name }));
  childrenOptions.sort((a, b) => roleListOrder.indexOf(a.value) - roleListOrder.indexOf(b.value));

  return (
    <SelectMui
      id="client_roles_select"
      label={label}
      name={name}
      options={childrenOptions}
      onChange={formInputChanged}
      value={value}
      defaultOptionLabel="Select one"
      hasDefaultOption
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        classes: { paper: menuClasses.menuPaper },
      }}
      {...remainingProps}
    />
  );
}

ClientRolesSelect.defaultProps = {
  valueName: 'name',
};
ClientRolesSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  formInputChanged: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  valueName: PropTypes.string,
};

export default ClientRolesSelect;
